export default __webpack_public_path__ + "static/media/omoda-logo-blue.svg.3d4ed657.svg";